import { __rest } from 'tslib';
import React from 'react';
import { Size } from '../../../styles/theme.mjs';
import { StyledLink, StyledPrimaryButton, StyledOutlineButton, StyledSecondaryButton } from './Button.styles.mjs';

const ButtonRenderer = (props) => {
    const { variant = 'primary', size = Size.Regular, children, ariaLabel } = props, rest = __rest(props, ["variant", "size", "children", "ariaLabel"]);
    switch (variant) {
        case 'secondary':
            return (React.createElement(StyledSecondaryButton, Object.assign({ size: size, "aria-label": ariaLabel }, rest), children));
        case 'outline':
            return (React.createElement(StyledOutlineButton, Object.assign({ size: size, "aria-label": ariaLabel }, rest), children));
        default:
            return (React.createElement(StyledPrimaryButton, Object.assign({ size: size, "aria-label": ariaLabel }, rest), children));
    }
};
const ButtonComponent = (_a) => {
    var { href } = _a, props = __rest(_a, ["href"]);
    if (href) {
        return (React.createElement(StyledLink, { href: href },
            React.createElement(ButtonRenderer, Object.assign({}, props))));
    }
    return React.createElement(ButtonRenderer, Object.assign({}, props));
};

export { ButtonComponent as default };
//# sourceMappingURL=Button.mjs.map
